import './popover.scss';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
var Popover = function Popover(_ref) {
  var content = _ref.content,
    _ref$params = _ref.params,
    params = _ref$params === void 0 ? '' : _ref$params,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    role: "tooltip",
    className: "react-popover ".concat(className)
  }, children, /*#__PURE__*/React.createElement("span", {
    className: "content"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-caret-up"
  }), /*#__PURE__*/React.createElement(T.md, {
    source: content,
    params: params,
    inline: true
  })));
};
export default Popover;